import { useEffect, useState } from 'react';

// Credit to: https://usehooks-ts.com/react-hook/use-debounce
function useDebounce<T>(value: T, delay = 0): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return debouncedValue;
}

export default useDebounce;
